import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function Register() {
  const { therapistRegister } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = React.useState({ name: "", email: "", password: "", organization: "" });
  const [err, setErr] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await therapistRegister(form);
      nav("/therapist", { replace: true });
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="sw-card p-8">
        <h1 className="display text-3xl font-bold">Therapist account</h1>
        <p className="text-[var(--sw-ink-soft)] mt-1">You&apos;ll add students after sign-up.</p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-sm font-semibold">Full name &amp; credentials</span>
            <input data-testid={TID.registerName} required value={form.name} onChange={onChange("name")} placeholder="e.g. Jordan Lee, OTR/L" className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Organization / School district <span className="text-[var(--sw-ink-soft)] font-normal">(optional)</span></span>
            <input data-testid="register-organization" value={form.organization} onChange={onChange("organization")} placeholder="e.g. Riverbend Unified School District" className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Email</span>
            <input data-testid={TID.registerEmail} type="email" required value={form.email} onChange={onChange("email")} className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Password</span>
            <input data-testid={TID.registerPassword} type="password" required minLength={6} value={form.password} onChange={onChange("password")} className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          {err && <div data-testid={TID.registerError} className="text-sm text-[var(--gusty-text)] bg-[var(--gusty-bg)] border border-[var(--gusty-border)] rounded-xl p-3">{err}</div>}
          <button data-testid={TID.registerSubmit} disabled={busy} className="sw-pill w-full h-12 justify-center bg-[var(--sw-primary)] text-white border-[var(--sw-primary)] text-base">
            {busy ? "Creating…" : "Create account"}
          </button>
          <p className="text-xs text-[var(--sw-ink-soft)] leading-relaxed">
            By creating an account you agree to our
            {" "}<Link to="/terms" className="underline text-[var(--sw-primary)]">Terms of Service</Link>
            {" "}and acknowledge our
            {" "}<Link to="/privacy" className="underline text-[var(--sw-primary)]">Privacy Policy</Link>.
            {" "}School districts: email <a href="mailto:Hello@occuthera.com" className="underline">Hello@occuthera.com</a> to request a signed DPA before creating multiple therapist accounts.
          </p>
        </form>
        <div className="mt-6 text-sm text-[var(--sw-ink-soft)]">
          Already a therapist? <Link to="/login" className="text-[var(--sw-primary)] font-semibold underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
